import { render, staticRenderFns } from "./ProductCategoriesModal.vue?vue&type=template&id=fbb91aae&scoped=true&"
import script from "./ProductCategoriesModal.vue?vue&type=script&lang=ts&"
export * from "./ProductCategoriesModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCategoriesModal.vue?vue&type=style&index=0&id=fbb91aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb91aae",
  null
  
)

export default component.exports